export default __webpack_public_path__ + "static/media/icon-circuit-loader.93bb2d8c.gif";